
import { singleton } from "../fable_modules/fable-library-js.5.0.0-rc.2/AsyncBuilder.js";
import { ValidationOnGetRequest } from "../ErrorHandling.js";
import swr from "swr";
import { concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../CommunicationV2.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { singleton as singleton_1 } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { ApiKeyDto_$reflection } from "../Shared/User.js";
import { list_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";

export function Async_valueOrRaise(request) {
    return singleton.Delay(() => singleton.Bind(request, (_arg) => {
        const response = _arg;
        return (response.tag === 1) ? singleton.Return((() => {
            throw new ValidationOnGetRequest(response.fields[0]);
        })()) : singleton.Return(response.fields[0]);
    }));
}

export function SWR_getApiKeys(apiReceiverId) {
    return swr(concat("/api/receivers/api-receivers/", apiReceiverId, ..."/api-keys"), (url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(ApiKeyDto_$reflection())));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })));
}

